import { EhrDataListItem } from 'chaika-frontend-types/frontend-cms';

import { DateFormat, DateHelper } from '@utils/DateHelper';

import { LabelFormat } from '../constants';

export function makePatientLabel(patient: EhrDataListItem, labelFormat: LabelFormat[]): string {
    return labelFormat.map(format => getLabelItem(patient, format)).join(', ');
}

function getLabelItem(patient: EhrDataListItem, format: LabelFormat): string {
    const { lastName, firstName, recordId, birthDate, phone, patronymic } = patient;

    switch (format) {
        case LabelFormat.FullName:
            return `${lastName || ''} ${firstName || ''} ${patronymic || ''}`;
        case LabelFormat.ShortFullName:
            return `${lastName || ''} ${firstName || ''}`;
        case LabelFormat.BirthDay:
            return birthDate ? DateHelper.format(birthDate, DateFormat.DateWithDotSeparator) : '';
        case LabelFormat.Phone:
            return phone || '';
        case LabelFormat.RecordId:
            return `№${recordId}`;
    }
}
